import React from 'react';
import { Location } from 'history';

import { Flex } from '@rover/kibble/core';
import BackToSearchButton from '@rover/react-lib/src/pages/sitter-profile/components/BackToSearchButton';
import ContactButton from '@rover/react-lib/src/pages/sitter-profile/components/ContactButton';
import FavoriteButton from '@rover/react-lib/src/pages/sitter-profile/components/FavoriteButton';
import PromoteProfileButton from '@rover/react-lib/src/pages/sitter-profile/SitterProfilePage/components/PromoteProfileButton';
import SitterInformation from '@rover/react-lib/src/pages/sitter-profile/SitterProfilePage/components/SitterInformation/SitterInformation';
import type { EnhancedPersonSitterProfile } from '@rover/rsdk/src/apiClient/latest/model/enhancedPersonSitterProfile';

import EditProfileButton from '../RevampServicesCta/EditProfileButton';

import { getShouldShowFavoriteButton } from './profileHeaderUtils';

export type DesktopProfileHeaderProps = {
  sitterInfo: EnhancedPersonSitterProfile;
  sitterImage: string;
  ownProfile: boolean;
  isApproved: boolean;
  isUnderReview: boolean;
  isImportedCiafSitterWithResetIdv?: boolean;
  onAvatarClick: (index: number) => void;
  onError: (error: string) => void;
  location: Location;
  service?: string;
  serviceType?: string;
  searchParams: URLSearchParams;
  isLoggedIn?: boolean;
  isInLaunchedCountry: boolean;
  contactUrl: string;
  sitterSlug: string;
  shouldShowPromoteProfileButton?: boolean;
  onReviewsCountPress?: () => void;
};

const DesktopProfileHeader = ({
  sitterInfo,
  sitterImage,
  ownProfile,
  isApproved,
  isUnderReview,
  isImportedCiafSitterWithResetIdv,
  onAvatarClick,
  onError,
  location,
  service,
  serviceType,
  searchParams,
  isLoggedIn,
  isInLaunchedCountry,
  contactUrl,
  sitterSlug,
  shouldShowPromoteProfileButton,
  onReviewsCountPress,
}: DesktopProfileHeaderProps): JSX.Element => {
  const shouldShowFavoriteButton = getShouldShowFavoriteButton(
    sitterInfo,
    ownProfile,
    isApproved,
    location
  );

  return (
    <Flex width="100%" alignItems="center" pt="6x" pb="4x" justifyContent="flex-end" gap="2x">
      <SitterInformation
        sitter={sitterInfo}
        sitterImage={sitterImage}
        ownProfile={ownProfile}
        isApproved={isApproved}
        isUnderReview={isUnderReview}
        isImportedCiafSitterWithResetIdv={isImportedCiafSitterWithResetIdv}
        onAvatarClick={onAvatarClick}
        isInLaunchedCountry={isInLaunchedCountry}
        onError={onError}
        location={location}
        shouldShowRevampLayout
        onReviewsCountPress={onReviewsCountPress}
      />
      {!ownProfile && (
        <BackToSearchButton
          serviceType={service}
          searchParams={searchParams}
          shouldShowRevampLayout
        />
      )}
      {shouldShowFavoriteButton && (
        <FavoriteButton
          sitterInfo={sitterInfo}
          isLoggedIn={isLoggedIn}
          onError={onError}
          location={location}
        />
      )}
      {!ownProfile && isApproved && isInLaunchedCountry && (
        <ContactButton
          sitterInfo={sitterInfo}
          contactUrl={contactUrl}
          sitterSlug={sitterSlug}
          isLoggedIn={isLoggedIn}
          location={location}
          pagePosition="main"
          shouldShowRevampLayout
        />
      )}
      {ownProfile && <EditProfileButton serviceType={serviceType} />}
      {shouldShowPromoteProfileButton ? <PromoteProfileButton isRevampLayout /> : null}
    </Flex>
  );
};

export default DesktopProfileHeader;
